import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunk from 'redux-thunk';
import { createBrowserHistory as createHistory } from 'history';
import rootReducer from 'redux/reducers';
import config from 'config';

export const history = createHistory();

const defaultState = {};
const enhancers = [];
const middleware = [thunk, routerMiddleware(history)];

if (config.env !== 'production') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
  if (typeof devToolsExtension === 'function') enhancers.push(devToolsExtension());
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(rootReducer, defaultState, composedEnhancers);

export default store;
